import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { HttpRequest, HttpHandler, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    // On the server (SSR/prerender) storage is not available
    if (!isPlatformBrowser(this.platformId)) {
      return next.handle(req);
    }

    // Busca o token diretamente do storage (prioriza sessionStorage)
    const token = sessionStorage.getItem('accessToken') || localStorage.getItem('accessToken');

    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`}});
    }

    return next.handle(req);
  }
}
